module.exports = __webpack_public_path__ + "res/img/jifen.ba08971e.png";